import type { ApplicationVersionResourceListResponseApi } from '@ingenico/api-sdk-device-management-private';
import type { ApplicationVersionResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import type { ApplicationVersionListResponseFront } from '../../models/applicationVersion.model';
import type { SelectItems } from '../../models/selectItems.model';

export function mapApplicationVersionResourceReadApi(
  response: ApplicationVersionResourceListResponseApi,
): ApplicationVersionListResponseFront {
  return {
    pagination: response.pagination,
    data: response.data.map((version) => ({
      applicationId: version.applicationId,
      id: version.id,
      versionNumber: version.versionNumber,
      longDescription: version.longDescription,
      shortDescription: version.shortDescription,
    })),
  };
}

export function mapSearchApplicationVersionToSelectItems({
  data,
}: ApplicationVersionResourceListResponseV2Api): SelectItems[] {
  return data.map(({ id, versionNumber }) => ({ id: toString(id), label: toString(versionNumber) }));
}
